export class FileTemplateVersion {
  id: number;
  versionNumber: number;
  fileName: string;
}
